module.exports = __webpack_public_path__ + "static/media/frog.f0b42243.svg";